import React, { useRef } from 'react'

import Card from '../../components/audience-insights/template/components/Card.jsx'
import Grid from '../../components/audience-insights/template/components/Grid.jsx'

import sectionBgSeasonality from '_static/img/audience-insights/slides/section_bg-seasonality.png'

import Horizontal from '../../components/audience-insights/template/layouts/Horizontal.jsx'
import Vertical from '../../components/audience-insights/template/layouts/Vertical.jsx'
import Section from '../../components/audience-insights/template/layouts/Section.jsx'
import Intro from '../../components/audience-insights/template/layouts/Intro.jsx'
import Outro from '../../components/audience-insights/template/layouts/Outro.jsx'
import Multiline from '../../components/audience-insights/template/layouts/Multiline.jsx'

import exportPresentation from '_modules/export-svg-as-pptx/index.js'

// DEMO CHARTS
// multiline
import { formatData as FORMAT_MULTILINE } from '../../components/audience-insights/charts/helpers/formatters'

import useRect from '../../components/audience-insights/template/hooks/useRect.js'

import PieChartHOC from '../../components/audience-insights/template/charts/PieChartHOC.jsx'
import BarChartHOC from '../../components/audience-insights/template/charts/BarChartHOC.jsx'
import BarStackedHOC from '../../components/audience-insights/template/charts/BarStackedHOC.jsx'

const MULTILINE_CHART_DATA = {
  BMW: {
    '2021-02-01': 250854,
    '2021-03-01': 250814,
    '2021-04-01': 164134,
    '2021-05-01': 150636,
    '2021-06-01': 123595,
    '2021-07-01': 114326,
    '2021-08-01': 138674,
    '2021-09-01': 268032,
    '2021-10-01': 208964,
    '2021-11-01': 217731,
    '2021-12-01': 303749,
    '2022-01-01': 308491,
  },
  Audi: {
    '2021-02-01': 233229,
    '2021-03-01': 195947,
    '2021-04-01': 174318,
    '2021-05-01': 150897,
    '2021-06-01': 158693,
    '2021-07-01': 126578,
    '2021-08-01': 160850,
    '2021-09-01': 303755,
    '2021-10-01': 246086,
    '2021-11-01': 224838,
    '2021-12-01': 251843,
    '2022-01-01': 272966,
  },
}

const PIE_CHART_DATA = [
  {
    key: 'BMW',
    value: 0.2,
  },
  {
    key: 'Audi',
    value: 0.8,
  },
]

const BAR_DATA = [
  {
    key: '18-24',
    value: 0.2,
  },
  {
    key: '25-34',
    value: 0.29995,
  },
  {
    key: '35-44',
    value: 0.30005,
  },
  {
    key: '45-Plus',
    value: 0.2,
  },
]

// OUTDATED
const BAR_STACKED_DATA = [
  {
    labels: ['Chrysler', 'Ford Motor', 'General Motors'],
    name: 'positive',
    values: [0.61, 0.54, 0.9],
  },
  {
    labels: ['Chrysler', 'Ford Motor', 'General Motors'],
    name: 'neutral',
    values: [0.19, 0.23, 0.07],
  },
  {
    labels: ['Chrysler', 'Ford Motor', 'General Motors'],
    name: 'negative',
    values: [0.2, 0.23, 0.03],
  },
]

export default function SlidesDemo() {
  const introRef = useRef()
  const outroRef = useRef()
  const horizontalRef = useRef()
  const verticalRef = useRef()
  const sectionRef = useRef()
  const multilineRef = useRef()

  // TODO: make this work (almost there)
  const exportSlide = () => {
    const slides = [
      // --force lint new lines
      introRef,
      horizontalRef,
      verticalRef,
      multilineRef,
      sectionRef,
      outroRef,
    ]

    const SVGs = slides.map((slide) => slide.current)

    let serializer = new XMLSerializer()

    const images = SVGs.map((svg) => serializer.serializeToString(svg))

    exportPresentation(images, `test - ${new Date().toUTCString()}`)
  }

  const [Card1Rect, card1Rect] = useRect()
  const [Card2Rect, card2Rect] = useRect()
  const [Card3Rect, card3Rect] = useRect()

  const multilineData = FORMAT_MULTILINE(MULTILINE_CHART_DATA)

  return (
    // wrapper
    <div
      className="slides-demo-wrapper"
      style={{ backgroundColor: '#eee', width: '100%', paddingRight: '2rem' }}
    >
      <button onClick={exportSlide}>Export test</button>
      <div>
        {/* content */}
        {/* a `template` will have as first tag a `Slide` that implements some predefined structure */}
        <Intro ref={introRef} title="Home Buying" description="(cloned at 2021-01-13 12:23:29)" />
        <div style={{ height: 50 }} />
        <Horizontal
          ref={horizontalRef}
          title="Competitive Landscape"
          description="The users in this audience may have interest in similar products to yours. After understanding your audience’s behavior and interest, this competitivelandscape helps you gain an understanding of your audience’s interest."
          page={4}
          // notes="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis vero numquam doloremque adipisicing elit. Corporis vero numquam doloremque adipisicing elit. Corporis vero numquam doloremque."
          content={() => (
            <Card
              title="COMPETITOR DISTRIBUTION (%):"
              description="(total searches, clicks, and shares)"
              showBorder={false}
            >
              <Card1Rect />
              {/* <PieChartHOC data={PIE_CHART_DATA} legendPosition="bottom" /> */}
              {/* <BarChartHOC data={BAR_DATA} valueType="percent" /> */}
              <BarStackedHOC data={BAR_STACKED_DATA} />
            </Card>
          )}
        />
        <div style={{ height: 50 }} />
        <Vertical
          ref={verticalRef}
          title="Audience Comparison"
          description="Compare online content consumption habits throughout the year among different audiences and verticals to determine the best time to reach your most engaged consumers."
          page={4}
          content={() => (
            <Grid
              direction="horizontal"
              gap={48}
              items={[
                {
                  component: (
                    <Card
                      title="ENGAGEMENT BY WEEK:"
                      description="(total searches, clicks and shares)"
                      showBorder={true}
                    >
                      {/* <PieChartHOC data={PIE_CHART_DATA} legendPosition="right" /> */}
                      <BarChartHOC data={BAR_DATA} valueType="percent" />
                      {/* <BarStackedHOC data={BAR_STACKED_DATA} /> */}
                    </Card>
                  ),
                  size: 0.4,
                },
                {
                  component: (
                    <Card
                      title="ENGAGEMENT BY WEEK:"
                      description="(total searches, clicks and shares)"
                      showBorder={true}
                    >
                      <PieChartHOC data={PIE_CHART_DATA} legendPosition="right" />
                      {/* <BarChartHOC data={BAR_DATA} valueType="percent" /> */}
                      {/* <BarStackedHOC data={BAR_STACKED_DATA} /> */}
                    </Card>
                  ),
                  size: 0.6,
                },
              ]}
            />
          )}
        />
        <div style={{ height: 50 }} />
        <Multiline
          ref={multilineRef}
          title="Audience Comparison"
          description="Compare online content consumption habits throughout the year among different audiences and verticals to determine the best time to reach your most engaged consumers."
          page={4}
          timeFrame="week_of_year"
          notes="(total searches, clicks and shares)"
          data={multilineData}
        />
        <div style={{ height: 50 }} />
        <Section
          ref={sectionRef}
          title="Seasonality"
          backgroundImage={sectionBgSeasonality}
          showLogo={true}
        />
        <div style={{ height: 50 }} />
        <Outro ref={outroRef} name="John Doe" email="johndoe@email.com" />
      </div>
    </div>
  )
}
